(function () {
    let healthcareDisclaimer = {
        selectors: {
            healthcareDisclaimerAlert: '.healthcare-disclaimer-alert',
            confirmBtn: '.healthcare-disclaimer-alert__btn',
        },

        elements: {
            healthcareDisclaimerAlertEl: null,
            confirmBtnEL: null,
        },

        classes: {
            displayNone: 'd-none',
        },

        init: function () {
            healthcareDisclaimer.control();
        },

        control: function () {
            healthcareDisclaimer.elements.healthcareDisclaimerAlertEl = document.querySelector(
                healthcareDisclaimer.selectors.healthcareDisclaimerAlert
            );
            healthcareDisclaimer.elements.confirmBtnEl = document.querySelector(
                healthcareDisclaimer.selectors.confirmBtn
            );

            healthcareDisclaimer.elements.confirmBtnEl.addEventListener(
                'click',
                healthcareDisclaimer.hideHealthcareDisclaimerAlert
            );
        },

        getHostName: function () {
            const hostname = window.location.hostname;
            let rootDomain;
            if (hostname.includes('onlinelibrary.wiley.com')) {
                rootDomain = '.onlinelibrary.wiley.com';
            } else if (hostname.includes('literatumonline.com')) {
                const parts = hostname.split('.');
                if (parts.length >= 3) {
                    rootDomain = `.${parts.slice(-3).join('.')}`; // e.g., .pericles-stag.literatumonline.com
                } else {
                    rootDomain = '.literatumonline.com';
                }
            } else {
                rootDomain = hostname;
            }
            return rootDomain;
        },

        hideHealthcareDisclaimerAlert: function () {
            let date = new Date();
            date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);

            healthcareDisclaimer.elements.healthcareDisclaimerAlertEl.classList.add(
                healthcareDisclaimer.classes.displayNone
            );

            document.cookie = `professional-disclaimer=confirm; expires=${date.toUTCString()}; path=/; domain=${healthcareDisclaimer.getHostName()}`;
        },
    };

    UX.healthcareDisclaimer = healthcareDisclaimer;
})();
